import * as React from 'react';
import Asset from '../../shared/models/Asset';
import {identity} from '../../core/auth/identityAuth';
import HttpService from '../../../modules/core/services/HttpService';
import Loading from '../../shared/components/loading/Loading';

import { withStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import BreadCrumb from '../../shared/components/BreadCrumb'

import SiteCoreService from '../../../modules/core/services/SiteCoreService'
import AssetCard from '../../consumer/components/AssetCard'
import Input from '@material-ui/core/Input'
import Hidden from '@material-ui/core/Hidden'
import IconButton from '@material-ui/core/IconButton'
import ListIcon from '@material-ui/icons/Menu'
import GridIcon from '@material-ui/icons/Apps'
import SearchIcon from '@material-ui/icons/Search'
import { ISitecoreAsset } from "../../shared/models/SitecoreAsset";

const httpService = HttpService.Instance;
const siteCoreService = SiteCoreService.Instance

const styles = {
  buttonIcon: {
    width: '80%',
    height: '80%'
  },
  IconButton: {
    width: 40,
    height: 40
  }
};

interface IState {
  providerAssets: Asset[]
  isLoading: boolean
  sitecoreAssets: ISitecoreAsset[]
  isList: boolean
  searchText: string
}

class ProviderAssets extends React.Component<any, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      providerAssets: [],
      isLoading: true,
      sitecoreAssets: [],
      isList: false,
      searchText: "",
    }
  }

  public async getProviderAssets(entityId: string): Promise<Asset[]> {
    const response = await httpService.get(process.env.REACT_APP_API_URL + 'entity/' + entityId + '/providerassets');
    if (response.ok) {
      return response.json();
    }
    return [];
  }

  public async componentDidMount() {
    const [providerAssets, sitecoreAssets]: [Asset[], ISitecoreAsset[]] = await Promise.all([
      this.getProviderAssets(identity['nxt:entity:id']),
      siteCoreService.getAllSiteCoreAssets()
    ])

    this.setState({ providerAssets, sitecoreAssets, isLoading: false });
  }

  public inSearch(searchString: string, regex: string) {
    if (searchString === "") {
      return true;
    }
    searchString = searchString.toLowerCase();
    regex = regex.toLowerCase();
    try {
      return searchString.search(regex) !== -1;
    } catch (error) {
      return false;
    }

  }

  public render() {
    const { classes } = this.props;
    const { isLoading, searchText, providerAssets, sitecoreAssets, isList } = this.state;

    return (
      <div>
        <Grid container justify="space-between" spacing={16} className="padding-bottom-24">
          <Grid item>
            <Typography variant='title'>
              {identity['nxt:entity:name']}
            </Typography>
            <Typography color="textSecondary" gutterBottom>
              <BreadCrumb
                value='Console'
                to='/'
              />
              Provider
            </Typography>
          </Grid>
          <Grid item>
            <Input
              value={searchText}
              onChange={(e) => this.setState({ searchText: e.target.value })}
              endAdornment={<SearchIcon />}
            />
            <Hidden smDown>
              <IconButton
                className={classes.IconButton}
                color="default"
                onClick={() => this.setState({ isList: true })}
              >
                <ListIcon className={classes.buttonIcon} />
              </IconButton>
              <IconButton
                className={classes.IconButton}
                color="default"
                onClick={() => this.setState({ isList: false })}
              >
                <GridIcon className={classes.buttonIcon} />
              </IconButton>
            </Hidden>
          </Grid>
        </Grid>
        {isLoading &&
          <Loading />
        }
        {!isLoading &&
          <div>
            {providerAssets.length < 1 && 
              <div>
                <Typography>
                  Your entity is currently not sharing any data through NxtPort. 
                </Typography>
                {providerAssets.length < 1 && process.env.ENVIRONMENT === 'PRODUCTION' &&
                  <Typography>
                    Take a look in our <a href={process.env.REACT_APP_PUBLIC_WEBSITE_URL + "/en/market/our-marketplace/marketplace"} target="_blank">Marketplace</a> to see which data is already shared through our platform. In case you would like to share data (through new or existing API's) with your community, <a href="https://nxtport.atlassian.net/servicedesk/customer/portal/1/group/3" target="_blank">contact us</a>.
                  </Typography>
                }
              </div>
            }
            <Grid container spacing={isList ? 0 : 16} justify="flex-start" alignItems="stretch">
              {providerAssets.filter((asset: any) => this.inSearch(asset.name, searchText)).map((asset: any) => {
                return (
                  <Grid key={asset.id} item xs={12} sm={isList ? 12 : 6} md={isList ? 12 : 4} lg={isList ? 12 : 3}>
                    <AssetCard
                      asset={sitecoreAssets.find(i => i.id === asset.id)}
                      ownerId={asset.owner}
                      name={asset.name}
                      horizontal={isList}
                      buttons={[{ name: "details", link: '/providerassets/' + asset.id + '/settings' }]}
                    />
                  </Grid>

                )
              })}
            </Grid>
          </div>
        }
      </div>
    )
  }
}

export default withStyles(styles)(ProviderAssets);


// WEBPACK FOOTER //
// ./src/modules/provider/pages/ProviderAssets.tsx